export default __webpack_public_path__ + "static/media/lightbulb-solid.8d62fb45.svg";